import { createApi } from '@reduxjs/toolkit/query/react';

import {
  BillsEndpointPaths,
  BillsEndpoints as Endpoints,
  type CreateThreeDsUrlRequest,
  type CreateThreeDsUrlResponse,
  type DeleteBillRequest,
  type DeleteBillResponse,
  type GetBillByIdRequest,
  type GetBillByIdResponse,
  type GetFilterDataRequest,
  type GetFilterDataResponse,
  type GetSearchResultRequest,
  type GetSearchResultResponse,
  type SearchBillsRequest,
  type SearchBillsResponse,
  type UpdateBillRequest,
  type UpdateBillResponse,
} from '@app/api/Bills/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';

export const billsApi = createApi({
  reducerPath: 'billsApi',
  baseQuery: createApiBaseQuery('/Bills'),
  endpoints: ({ mutation, query }) => ({
    [Endpoints.GetFilterData]: query<
      GetFilterDataResponse,
      GetFilterDataRequest
    >({
      query: (params) => ({
        url: BillsEndpointPaths[Endpoints.GetFilterData],
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.SearchBills]: mutation<SearchBillsResponse, SearchBillsRequest>({
      query: ({ data, ...params }) => ({
        url: BillsEndpointPaths[Endpoints.SearchBills],
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.GetSearchResult]: query<
      GetSearchResultResponse,
      GetSearchResultRequest
    >({
      query: (params) => ({
        url: BillsEndpointPaths[Endpoints.GetSearchResult],
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetBillById]: query<GetBillByIdResponse, GetBillByIdRequest>({
      query: (params) => ({
        url: BillsEndpointPaths[Endpoints.GetBillById],
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.UpdateBill]: mutation<UpdateBillResponse, UpdateBillRequest>({
      query: ({ data, ...params }) => ({
        url: BillsEndpointPaths[Endpoints.UpdateBill],
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.DeleteBill]: mutation<DeleteBillResponse, DeleteBillRequest>({
      query: (params) => ({
        url: BillsEndpointPaths[Endpoints.DeleteBill],
        method: Methods.POST,
        params,
      }),
    }),
    [Endpoints.CreateThreeDsUrl]: mutation<
      CreateThreeDsUrlResponse,
      CreateThreeDsUrlRequest
    >({
      query: (params) => ({
        url: BillsEndpointPaths[Endpoints.CreateThreeDsUrl],
        method: Methods.POST,
        params,
      }),
    }),
  }),
});

export const {
  useGetFilterDataQuery,
  useLazyGetFilterDataQuery,
  useSearchBillsMutation,
  useGetSearchResultQuery,
  useLazyGetSearchResultQuery,
  useGetBillByIdQuery,
  useLazyGetBillByIdQuery,
  useUpdateBillMutation,
  useDeleteBillMutation,
  useCreateThreeDsUrlMutation,
} = billsApi;
